import BaseComponent from "../../../baseComponent.js";
import React from "react";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import TimeLineControl from "./time-line-control/timeLineControl.jsx";
import ChartUtil from "./chart-util.js";
import styles from "./chart.scss";
import WidgetType from "../../../../core/constants/widgetType.js";
import Resolutions from "./resolutions";


const LineBarChartComponentController = require('./controller.js');

export default class Chart extends BaseComponent {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.componentController = new LineBarChartComponentController(
      this.props.widgetId,
      this.props.legends,
      this.props.metaData,
      this.props.isVertical,
      this.props.isAddOrEditWidget);

    WidgetService.addComponentToWidget(this.props.widgetId, this.componentController);

    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.resizeWidget(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.resizeWidget(payload));

    this.$actions = $(this.refs.actions);
    this.$actions.parents(".widget, #preview-widget").hover(() => {
      this.$actions.find("i").stop().fadeIn();
      this.$actions.find("div").stop().fadeIn();
    }, () => {
      this.$actions.find("i").stop().fadeOut();
      this.$actions.find("div").stop().fadeOut();
      if (this.refs.resolutions) {
        this.refs.resolutions.closeMenu(null, true);
      }
    });
  }

  componentWillUnmount() {
    this.componentController.destroy();
    this.unsubscribeAll();
  }


  resizeWidget(data) {
    let widget = data.widget;
    let newHeight = data.height || $(widget).height();
    let newWidth = data.width || $(widget).width();
    let widgetId = $(widget.children("div")[0]).attr("id");
    const widgetModel = WidgetService.getWidget(widgetId);

    if (this.props.widgetId === widgetId) {
      ChartUtil.resizeCharts(widgetId, newHeight, newWidth, widgetModel.type === WidgetType.TIME_SERIES_VERTICAL);
    }
  }

  handleResolutionChange(resolution) {
    WidgetService.updateWidgetMetaData(this.props.widget.id, { resolution });
    const hasServerSideFunctions = WidgetService.doesComponentRequireServerSideFunctions(this.props.widget.legends);
    if (hasServerSideFunctions) {
      const widget = WidgetService.getWidget(this.props.widget.id);
      this.publish(InternalEvent.Dashboard.CHART_RESET, widget)
    } else {
      // this.publish('resolution-change', {widgetId: this.props.widget.id, resolution});
      this.componentController.updateUserLastAction();
      const widget = WidgetService.getWidget(this.props.widget.id);
      this.publish(InternalEvent.Dashboard.CHART_RESET, widget)
    }
    this.publish(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE);
  }

  render() {
    let style, style2, style3;
    const divId = `${this.props.widgetId}-chart`;

    if (this.props.isVertical) {
      style = {
        transform: 'rotate(270deg)',
        transformOrigin: 'top left'
      };
      style2 = {
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 35
      };
      style3 = {
        transform: 'rotate(90deg)',
        background: 'transparent'
      }
    }
    return (
      <div id={divId} className={["epoch category10 chart-widget-main-chart", styles.container].join(" ")}
        style={style}
        ref="container">
        <div className={styles.chartActions} ref="actions" style={style2}>
          <Resolutions changeResolution={this.handleResolutionChange} widgetId={this.props.widget.id} ref="resolutions"
            isVertical={this.props.isVertical} />
          <i className="icon-settings"
            onClick={() => this.publish('openTimeSeriesWidgetConfig', this.props.widget)} style={style3} />
          <i className="icon-clock"
            onClick={() => this.publish('openTimeControl', this.props.widget)}
            style={style3} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/chart.jsx